module.exports = __webpack_public_path__ + "img/bridge2.1f0a2083.png";